<template>
    <section
        class="filters-panel filters-panel--border-bottom row filters-panel__row"
    >
        <div class="col-lg-5 filters-panel__col d-flex d-lg-block">
            <div class="filters-panel-search">
                <label
                    class="filters-panel-search__label"
                    for="filters-panel-search__input"
                ></label>
                <input
                    id="filters-panel-search__input"
                    type="text"
                    name=""
                    class="app-input filters-panel-search__input"
                    placeholder="Поиск"
                    disabled
                />
            </div>
            <button
                type="button"
                class="cabinet-btn cabinet-btn--default filters-panel__mob-btn d-lg-none ml-3 js-open-mob-filters"
            >
                Фильтры
            </button>
        </div>
        <div class="col-lg-2 filters-panel__col d-none d-lg-block">
            <div class="loading-state__filter"></div>
        </div>
        <div class="col-lg-2 filters-panel__col d-none d-lg-block">
            <div class="loading-state__filter"></div>
        </div>
        <div class="col-lg-2 filters-panel__col d-none d-lg-block">
            <div class="loading-state__filter"></div>
        </div>
        <div class="col-lg-2 filters-panel__col d-none d-lg-block">
            <div class="loading-state__filter"></div>
        </div>
        <div class="col-lg-2 filters-panel__col d-none d-lg-block">
            <div class="loading-state__filter"></div>
        </div>
        <div class="col-lg-2 filters-panel__col d-none d-lg-block">
            <div class="loading-state__filter"></div>
        </div>
        <div class="col-lg-2 filters-panel__col d-none d-lg-block">
            <div class="loading-state__filter"></div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'FiltersLoading'
}
</script>
